var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
/**
 * @fileoverview added by tsickle
 * Generated from: models/visit-rating.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { defineModelProperties, model } from '../util/model';
/**
 * A rating greater than or equal to this value is considered "High".
 * A rating less than this value is considered "Low".
 * @type {?}
 */
var HIGH_RATING_THRESHOLD = 4;
/** @enum {string} */
var VisitRatingCompliment = {
    AboveBeyond: "above_beyond",
    BestCleaner: "best_cleaner",
    Cleaning: "cleaning",
    Efficiency: "efficiency",
    MadeDay: "made_day",
    PetFriendly: "pet_friendly",
    Politeness: "politeness",
    RightOnTime: "right_on_time",
    Service: "service",
    Thoroughness: "thoroughness",
    Tidying: "tidying",
};
export { VisitRatingCompliment };
/** @type {?} */
export var COMPLIMENT_LABELS = new Map([
    [VisitRatingCompliment.AboveBeyond, 'Above & Beyond'],
    [VisitRatingCompliment.BestCleaner, 'Best Cleaner Ever'],
    [VisitRatingCompliment.Cleaning, 'Cleaning Genius'],
    [VisitRatingCompliment.Efficiency, 'Quick & Efficient'],
    [VisitRatingCompliment.MadeDay, 'Made My Day'],
    [VisitRatingCompliment.PetFriendly, "Pet's Best Friend"],
    [VisitRatingCompliment.Politeness, 'Polite & Friendly'],
    [VisitRatingCompliment.RightOnTime, 'Right On Time'],
    [VisitRatingCompliment.Service, 'Excellent Service'],
    [VisitRatingCompliment.Thoroughness, 'Incredibly Thorough'],
    [VisitRatingCompliment.Tidying, 'Beautiful Tidying']
]);
/** @type {?} */
export var TRADESPERSON_COMPLIMENT_LABELS = new Map([
    [VisitRatingCompliment.Efficiency, 'Quick & Efficient'],
    [VisitRatingCompliment.Politeness, 'Polite & Friendly'],
    [VisitRatingCompliment.Service, 'Excellent Service']
]);
/** @enum {string} */
var VisitRatingPhotoType = {
    Breakage: "breakage",
    Quality: "quality",
    Receipt: "receipt",
};
export { VisitRatingPhotoType };
/** @enum {string} */
var VisitRatingProblemCategory = {
    Quality: "quality",
    Breakage: "breakage",
    TheftAllegation: "theft_allegation",
    Timeliness: "timeliness",
    Professionalism: "professionalism",
    Other: "other",
};
export { VisitRatingProblemCategory };
/** @type {?} */
var COMMON_PROBLEM_CATEGORY_CHOICES = new Map([
    [VisitRatingProblemCategory.Breakage, 'Breakage'],
    [VisitRatingProblemCategory.Timeliness, 'Timeliness'],
    [VisitRatingProblemCategory.Professionalism, 'Professionalism'],
    [VisitRatingProblemCategory.Other, 'Other']
]);
/** @type {?} */
export var VISIT_RATING_PROBLEM_CATEGORY_CHOICES_CLEAN = new Map(__spread([
    [VisitRatingProblemCategory.Quality, 'Clean quality']
], COMMON_PROBLEM_CATEGORY_CHOICES));
/** @type {?} */
export var VISIT_RATING_PROBLEM_CATEGORY_CHOICES_TRADES = new Map(__spread([
    [VisitRatingProblemCategory.Quality, 'Job quality']
], COMMON_PROBLEM_CATEGORY_CHOICES));
/**
 * Model representing a photo associated with a visit rating.
 * @record
 */
export function VisitRatingPhoto() { }
if (false) {
    /** @type {?|undefined} */
    VisitRatingPhoto.prototype.name;
    /** @type {?|undefined} */
    VisitRatingPhoto.prototype.photo;
    /** @type {?} */
    VisitRatingPhoto.prototype.type;
    /** @type {?|undefined} */
    VisitRatingPhoto.prototype.url;
}
/** @type {?} */
export var visitRatingPhoto = model.extend((/** @type {?} */ ({
    modelName: 'visitRatingPhoto'
})));
/**
 * Base visit rating model, containing all fields returned by the API.
 * @record
 */
function BaseVisitRatingModel() { }
if (false) {
    /** @type {?} */
    BaseVisitRatingModel.prototype.allowPublish;
    /** @type {?} */
    BaseVisitRatingModel.prototype.allowPublishIncludeName;
    /** @type {?} */
    BaseVisitRatingModel.prototype.blockWorker;
    /** @type {?} */
    BaseVisitRatingModel.prototype.breakageCost;
    /** @type {?} */
    BaseVisitRatingModel.prototype.breakageItem;
    /** @type {?} */
    BaseVisitRatingModel.prototype.breakageRoom;
    /** @type {?} */
    BaseVisitRatingModel.prototype.compliment;
    /** @type {?} */
    BaseVisitRatingModel.prototype.complimentDisplay;
    /** @type {?} */
    BaseVisitRatingModel.prototype.isReviewable;
    /** @type {?} */
    BaseVisitRatingModel.prototype.isTippable;
    /** @type {?} */
    BaseVisitRatingModel.prototype.tipPounds;
    /** @type {?} */
    BaseVisitRatingModel.prototype.messageToHousekeeper;
    /** @type {?} */
    BaseVisitRatingModel.prototype.moreInfo;
    /** @type {?} */
    BaseVisitRatingModel.prototype.photos;
    /** @type {?} */
    BaseVisitRatingModel.prototype.problemCategory;
    /** @type {?} */
    BaseVisitRatingModel.prototype.rating;
    /** @type {?} */
    BaseVisitRatingModel.prototype.suppressLowRatingTicket;
    /** @type {?} */
    BaseVisitRatingModel.prototype.unfair;
    /** @type {?} */
    BaseVisitRatingModel.prototype.customer;
}
/**
 * Optional expandable fields that can be requested from the API.
 * @record
 */
function VisitRatingExpandables() { }
if (false) {
    /** @type {?|undefined} */
    VisitRatingExpandables.prototype.visit;
}
/**
 * Helper properties for the VisitRating model.
 * @record
 */
function VisitRatingMixin() { }
if (false) {
    /** @type {?} */
    VisitRatingMixin.prototype.isLow;
    /** @type {?} */
    VisitRatingMixin.prototype.isHigh;
    /** @type {?} */
    VisitRatingMixin.prototype.isOkay;
    /** @type {?|undefined} */
    VisitRatingMixin.prototype.problemCategoryDisplay;
}
/**
 * Model representing a visit rating submitted by a customer.
 * @record
 */
export function VisitRating() { }
/** @type {?} */
export var visitRating = model.extend((/** @type {?} */ ({
    modelName: 'visitRating'
})));
// Implements helper properties declared in VisitRatingMixin
defineModelProperties(visitRating, {
    isHigh: {
        get: /**
         * @return {?}
         */
        function () {
            return !!(this.rating && this.rating >= HIGH_RATING_THRESHOLD);
        }
    },
    isLow: {
        get: /**
         * @return {?}
         */
        function () {
            return this.rating === 0 || !!(this.rating && this.rating < HIGH_RATING_THRESHOLD);
        }
    },
    isOkay: {
        get: /**
         * @return {?}
         */
        function () {
            return !!(this.rating && this.rating === HIGH_RATING_THRESHOLD);
        }
    },
    problemCategoryDisplay: {
        get: /**
         * @return {?}
         */
        function () {
            return VISIT_RATING_PROBLEM_CATEGORY_CHOICES_CLEAN.get(this.problemCategory);
        }
    }
});
